import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { NotificationItem } from '../types';

interface MarkReadRequest {
  ids?: string[];
  all?: boolean;
}

export function useMarkRead() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: MarkReadRequest) => apiClient.post<void>('/notifications:markRead', body),
    onSuccess: (_data, variables) => {
      queryClient.setQueryData<NotificationItem[]>(queryKeys.notifications, (old) => {
        if (!old) return old;
        return old.map((n) => {
          if (variables.all || variables.ids?.includes(n.id)) {
            return { ...n, isRead: true };
          }
          return n;
        });
      });
    },
  });
}
